export const DOCUMENT_EDIT_ACTION_TITLE_FIELD_NAME = 'name'
